<div class="details-container">
  <div class="col-12 col-xxl-10 mx-auto ms-0 me-0 w-100">

    <app-chart-table-displayer *ngIf="pkStrategy" [pkName]="'FINPORT'"
                               [marketplaceAllocationStrategy]="pkStrategy"></app-chart-table-displayer>

  </div>
</div>
